import { render } from "./SiteDatenschutz.vue?vue&type=template&id=1a6fb29a&scoped=true"
import script from "./SiteDatenschutz.vue?vue&type=script&lang=js"
export * from "./SiteDatenschutz.vue?vue&type=script&lang=js"

import "./SiteDatenschutz.vue?vue&type=style&index=0&id=1a6fb29a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6fb29a"]])

export default __exports__